/* eslint-disable max-len */

import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import layout from '../style/layout';
import colors, { lighten } from '../style/colors';

class ModalDialog extends Component {
    render() {
        if (!this.props.isVisible) {
            return null;
        }

        const hasKeyboard = this.props.isKeyboardShown;

        return (
            <div className={`modal-dialog modal-dialog-${this.props.dialogClassName} ${this.props.className}`}>
                <div className="modal-dialog-fullscreen-overlay" onClick={this.props.onClose} />
                <div className={`modal-dialog-inner ${hasKeyboard ? 'with-shown-keyboard' : ''}`}>
                    <div className="modal-dialog-content">
                        <button className="close-dialog" onClick={this.props.onClose}>
                            <svg width="0.5em" height="0.5em" viewBox="168 231 31 31" version="1.1">
                                <polygon id="×" stroke="none" fill="#FFFFFF" fillRule="evenodd" points="180.121094 246.582031 168.90625 235.296875 172.351562 231.816406 183.601562 243.066406 194.957031 231.816406 198.4375 235.191406 187.046875 246.582031 198.367188 257.902344 194.957031 261.277344 183.601562 250.027344 172.351562 261.207031 168.976562 257.832031" />
                            </svg>
                        </button>
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

// Validate all props that are used inside the component to warn early if they're not supplied
// correctly
ModalDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    isVisible: PropTypes.bool,
    title: PropTypes.string,
    dialogClassName: PropTypes.string.isRequired,
    isKeyboardShown: PropTypes.bool,
};



const StyledModalDialog = styled(ModalDialog)`
    &,
    .modal-dialog-fullscreen-overlay,
    .modal-dialog-inner {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: start;
        transition: bottom 0.3s ease-out;
        ${layout.tabletOrDesktop('justify-content: center;')}
    }

    /* This is a hacky workaround because the Android SDK does not handle the keyboard-open case
       correctly yet. */
    .is-android .modal-dialog-inner.with-shown-keyboard {
        bottom: 48%;
    }

    .modal-dialog-content {
        max-width: 40em;
        max-height: 100%;
        position: relative;
        h1 {
            margin: .5em 0;
            font-size: 2em;
        }
        > button.close-dialog {
            position: absolute;
            left: 0;
            top: 0;
            font-size: 3em;
            line-height: 100%;
            width: 1em;
            height: 1em;
            cursor: pointer;
            background-color: ${colors.red};
            &:hover, &:active {
                background-color: ${lighten(colors.red)};
            }
        }
        button {
            border: none;
            outline: none;
            border-radius: 0;
            background-color: ${colors.violet};
            &:hover, &:active {
                background-color: ${lighten(colors.violet)};
            }
            font-size: 1em;
            color: white;
        }
    }

    .modal-dialog-fullscreen-overlay {
        background-color: rgba(0, 0, 0, 0.93);
    }

    .modal-dialog-content {
        box-sizing: border-box;
        background-color: white;
        overflow: scroll;
        color: #333;
        padding: 3em 1em 2em 1em;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    }
`;

export default StyledModalDialog;



// WEBPACK FOOTER //
// ./src/components/modal-dialog.jsx